<template>
  <img v-if="withText" src="/img/logo-text.svg" alt="" />
  <img v-else src="/img/logo.svg" alt="" />
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    withText?: boolean
  }>(),
  {
    withText: false,
  },
)
</script>
